'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002411 from "./presto.-Agent-View$$anon$11.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dError$0024 from "./presto.-Agent-View$-Error$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$10() {
  this.awm = null;
  this.awe = null;
  this.awf = false;
  this.awn = null;
  this.awo = false;
  this.awr = null;
  this.awk = null;
  this.awl = false;
  this.awg = null;
  this.awh = false;
  this.awi = null;
  this.awj = false;
  this.awp = false;
  this.awq = false;
  this.awm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.awr = "Error";
}
export { $c_Lpresto_AgentView$$anon$10 as $c_Lpresto_AgentView$$anon$10 };
$p = $c_Lpresto_AgentView$$anon$10.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$10;
/** @constructor */
function $h_Lpresto_AgentView$$anon$10() {
}
export { $h_Lpresto_AgentView$$anon$10 as $h_Lpresto_AgentView$$anon$10 };
$h_Lpresto_AgentView$$anon$10.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.awm;
});
$p.M = (function() {
  if ((!this.awf)) {
    this.awe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.awf = true;
  }
  return this.awe;
});
$p.O = (function() {
  if ((!this.awo)) {
    this.awn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.awo = true;
  }
  return this.awn;
});
$p.D = (function() {
  return this.awr;
});
$p.t = (function() {
  if ((!this.awl)) {
    this.awk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.awl = true;
  }
  return this.awk;
});
$p.N = (function() {
  if ((!this.awh)) {
    this.awg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.awh = true;
  }
  return this.awg;
});
$p.Q = (function() {
  if ((!this.awj)) {
    this.awi = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002411.$c_Lpresto_AgentView$$anon$11();
    this.awj = true;
  }
  return this.awi;
});
$p.v = (function() {
  if ((!this.awq)) {
    this.awp = false;
    this.awq = true;
  }
  return this.awp;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee71) => ((p) => \u03b4scrutinee71))($j_presto$002e$002dAgent$002dView$0024$002dError$0024.$m_Lpresto_AgentView$Error$())));
});
var $d_Lpresto_AgentView$$anon$10 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$10, "presto.AgentView$$anon$10", ({
  DE: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$10 as $d_Lpresto_AgentView$$anon$10 };
//# sourceMappingURL=presto.-Agent-View$$anon$10.js.map
